module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "p01"
    }
  }, [_c('div', {
    staticClass: "dis_img",
    attrs: {
      "id": "img5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/5-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("During a recording session at the Atlantic Records studio in New York, January 1969.")])]), _vm._v(" "), _c('h1', {
    staticClass: "part"
  }, [_vm._v("PART ONE")]), _vm._v(" "), _c('h1', {
    staticClass: "part1"
  }, [_c('strong', [_vm._v("Detroit")])]), _vm._v(" "), _c('div', {
    staticClass: "dis_img01",
    attrs: {
      "id": "img6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/6-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A portrait, c. 1964.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d440c4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454934721_p01.vue
// module id = 81
// module chunks = 0